import type { ExpertReportBlockTreeNode } from '@/entities/expert-report';

/**
 * Есть ли у блока собственный результат, а значит и своя колонка в таблице диалогов. Единственное
 * место, где это правило записано: по блоку с вложенными блоками итог считается всегда, поэтому
 * пометка «раздел» (`isHeader`) отсекает только листовой блок — по такому оценка не выставляется.
 * Расхождение любого перечня блоков с результатом (видимость, состав запроса, сами колонки)
 * с этим правилом даёт колонку без данных либо теряет её вовсе.
 */
export const hasOwnBlockResult = (block: ExpertReportBlockTreeNode): boolean =>
  Boolean(block.children?.length) || !block.isHeader;

/**
 * Возвращает ID всех блоков поддерева указанного блока (включая его самого), у которых есть
 * собственная колонка с результатом — по {@link hasOwnBlockResult}. ID блока с вложенными блоками
 * идёт последним: он одновременно и группа для потомков, и самостоятельный источник данных
 * (см. `buildBlockColumn` в `useDialogReportColumns`, где то же правило задаёт порядок колонок).
 */
export const collectResultBlockIds = (block: ExpertReportBlockTreeNode): number[] => {
  const childIds = (block.children ?? []).flatMap((child) => collectResultBlockIds(child));
  return hasOwnBlockResult(block) ? [...childIds, block.id] : childIds;
};
